<template>
  <div>
    <validation-observer ref="SliderValidation">
      <div style="max-width: 400px">
        <b-modal
          v-model="activDelete"
          cancel-variant="outline-secondary"
          centered
          title="تأكيد حذف  "
          size="md"
          footer-class="removed"
          class="edit-modal"
          id="modal"
          no-close-on-backdrop
        >
          <b-card-text> هل أنت متأكد من الحذف </b-card-text>
          <b-row class="px-1 justify-content-end">
            <b-button @click="activDelete = false" class="mx-1">إلغاء</b-button>
            <b-button
              variant="danger"
              @click="
                () => {
                  deleteSlider();
                  activDelete = false;
                }
              "
            >
              حذف
            </b-button>
          </b-row>
        </b-modal>

        <b-card class="border">
          <div style="position: relative">
            <b-img
              :src="imageSlideNgo"
              fluid-grow
              alt="Fluid-grow image')"
              height="150"
              class="mb-1"
              style="width: 100%; height: 150px"
            />
            <div
              @click="$refs.imageInputSlider.click()"
              style="
                position: absolute;
                top: 110px;
                left: 10px;
                z-index: 10;
                cursor: pointer;
              "
            >
              <feather-icon
                color="#eee"
                icon="EditIcon"
                size="30"
                style="z-index: 2"
              />
            </div>
            <input
              accept="image/*"
              type="file"
              name="image-slider"
              style="display: none"
              ref="imageInputSlider"
              @change="imageUploaded"
            />
          </div>

          <form-input
            label="العنوان"
            id="titleSlide"
            v-model="titleSlide"
            rules="required"
          />
          <b-form-group label="تفاصيل" label-for="largeInput">
            <validation-provider
              #default="{ errors }"
              name="experience"
              rules="required"
            >
              <b-form-textarea
                id="textarea-default"
                placeholder="Textarea"
                v-model="descriptionSlide"
                rows="3"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{
                errors[0] ? "الحقل مطلوب" : ""
              }}</small>
            </validation-provider>
          </b-form-group>
          <div class="d-flex justify-content-between">
            <b-button variant="danger" @click="activDelete = true">
              حذف <feather-icon icon="Trash2Icon" />
            </b-button>
            <!-- <save-btn
            class="ml-1"
            variant="success"
            :loading="editLoading"
            style="height: 40px"
            @click="formEditSlider()"
          >
          </save-btn> -->

            <b-button variant="success" type="submit" @click="formEditSlider()">
              تعديل <feather-icon icon="EditIcon" />
            </b-button>
          </div>
        </b-card>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import {
  BCard,
  BImg,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BButton,
  BModal,
  BRow,
  BCardText,
} from "bootstrap-vue";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input/index.vue";
import saveBtn from "@/components/loader-btn";
import { mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BImg,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BCardActions,
    BButton,
    BModal,
    BRow,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    FormInput,
    saveBtn,
  },
  props: ["info"],
  data() {
    return {
      activDelete: false,
      titleSlide: this.info.title,
      descriptionSlide: this.info.description,
      imageSlide: null,
      imageSliderSubmit: null,
    };
  },
  computed: {
    imageSlideNgo() {
      return this.imageSlide || this.info.source;
    },
    ...mapGetters("manageInterfaceNgo/ngoSlider", [
      "editLoading",
      "deleteLoading",
    ]),
  },
  methods: {
    imageUploaded(e) {
      this.imageSlide = URL.createObjectURL(e.target.files[0]);
      this.imageSliderSubmit = e.target.files[0];
    },
    formEditSlider() {
      this.$refs.SliderValidation.validate().then(async (success) => {
        if (success) {
          this.editSlider();
        }
      });
    },
    editSlider() {
      const fd = new FormData();
      if (this.imageSlide) {
        fd.append("source", this.imageSliderSubmit);
        // this.$refs.imageInputSlider.files[0]
      }
      fd.append("title", this.titleSlide);
      fd.append("description", this.descriptionSlide);
      this.$store.dispatch(`manageInterfaceNgo/ngoSlider/editSlide`, {
        fd: fd,
        id: this.info.slide_id,
      });
    },
    deleteSlider() {
      this.$store.dispatch(`manageInterfaceNgo/ngoSlider/deleteSlide`, {
        id: this.info.slide_id,
      });
    },
  },
};
</script>
